export const TenantStatusEnum = Object.freeze({
  Trial: 'trial',
  PendingPayment: 'pending_payment',
  Active: 'active',
  Blocked: 'blocked',
  Deleted: 'deleted',
});

export const TenantPlanEnum = Object.freeze({
  Lite: 'lite',
  Basic: 'basic',
  Pro: 'pro',
  Trial: 'trial',
});

export const CustomDomainStatusEnum = Object.freeze({
  PendingDns: 'pending_dns',
  Validating: 'validating',
  Active: 'active',
  Failed: 'failed',
});
